import { Text, View } from "@react-pdf/renderer";
import { TablePdfIngredients } from "./TablePdfIngredients";
import { styles } from "./styles/styles";
import { prepStepStyles } from "./styles/prepStepStyles";
import { Fragment } from "react";
import { RecipeType } from "@/types/baseTypes";

export const RecipePdfPrepSteps = ({
  recipeDetails,
}: {
  recipeDetails: RecipeType;
}) => {
  const listRegex = /<li>(.*?)<\/li>/gs;
  const ulRegex = /<ul>(.*?)<\/ul>/gs;

  return (
    <View style={styles.rightSide}>
      {recipeDetails.steps_portion_big.map((currentStep, i) => {
        let currentStepDescrArray =
          currentStep.step_beschreibung?.match(listRegex);
        if (!currentStepDescrArray || currentStepDescrArray.length === 0) {
          currentStepDescrArray = currentStep.step_beschreibung?.match(ulRegex);
        }
        return (
          <Fragment key={i}>
            {currentStep.step_titel ? (
              <Text style={styles.stepTitle}>
                {currentStep.step_titel.replace(/<[^>]*>/g, "")}
              </Text>
            ) : null}
            <View style={prepStepStyles.prepStep} key={i} wrap={false}>
              {currentStep.step_zutaten ? (
                <TablePdfIngredients
                  stepCat={currentStep.step_kategorie}
                  currentStepDescrArray={currentStepDescrArray}
                  ingredientList={currentStep.step_zutaten}
                />
              ) : null}
            </View>
          </Fragment>
        );
      })}
    </View>
  );
};
